<template>
  <div class="role-list">
    <ToolBar>
      <el-button type="primary" icon="el-icon-plus" size="small" @click="editRole(false)">添加教练</el-button>
      <!-- <div style="float: right">
        <el-input
          placeholder="请输入角色名称！"
          size="small"
          style="width: 140px"
          v-model="params.name"
          clearable
        ></el-input>
        <el-button type="success" icon="el-icon-search" size="small"></el-button>
      </div> -->
    </ToolBar>
    <el-table :data="coachData" border ref="table" style="width: 100%">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column prop="coachName" label="教练名称"></el-table-column>
      <el-table-column prop="autograph" label="简介"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            @click="editRole(scope.row)"
            type="primary"
            icon="el-icon-edit"
            size="small"
            circle
          ></el-button>
          <el-button
            @click="delRole(scope.row)"
            type="danger"
            icon="el-icon-delete"
            size="small"
            circle
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <coachEdit
      :title="roleEditTitle"
      :dialogFormVisible="dialogFormVisible"
      :data="currentEditRole"
      @getList="getList"
      @val-change="roleEditChange"
      @cancel="dialogFormVisible = false"
    ></coachEdit>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
import coachEdit from "./coach_edit.vue";

export default {
  data() {
    return {
      roleEditTitle: "教练信息",
      currentEditRole: false,
      dialogFormVisible: false,
      currentEditPermissions: false,
      params: {
        name: ""
      },
      coachData: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var that = this;
      that.loading = true;
      that.coachData = [];
      that.$axios
        .get(that.baseUrl + "/queryCoach")
        .then(res => {
          console.log(res);
          that.coachData = res.data;
          that.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    roleEditChange(data) {
      console.log(data);
      let self = this;

      self.$notify({
        title: self.roleEditTitle + "成功！",
        message: "自己对接Api,并调用你的初始化列表函数！",
        type: "success"
      });
      self.dialogFormVisible = false;
      // self.$Api.editRole(data,r=>{
      //   self.$message.success(self.roleEditTitle+'成功！');
      //   self.init();
      //   self.dialogFormVisible = false;
      // });
    },
    editRole(data) {
      if (data) {
        this.currentEditRole = data;
      } else {
        this.currentEditRole = false;
      }
      this.dialogFormVisible = true;
    },
    delRole(row) {
      this.$confirm("此操作将永久删除该教练, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios
            .get(this.baseUrl + "/delCoach?coachId=" + row.id)
            .then(res => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getList();
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    UploadRole(data) {}
  },
  components: {
    ToolBar,
    HelpHint,
    coachEdit
  }
};
</script>
<style lang="less">
</style>
